export const iscrizionis= [
     "Medici Chirurghi", 
     "Odontoiatri"
];
